import { shape, string } from 'prop-types';
import { DESKTOP, MOBILE } from 'mangools-commons/dist/constants/Platforms';
import TrackingWithStatsType from 'types/TrackingWithStatsType';

export default shape({
    id: string.isRequired,
    [DESKTOP.label]: TrackingWithStatsType,
    [MOBILE.label]: TrackingWithStatsType,
});
